import { ShieldCheck, Star, Users, TrendingUp, BookmarkCheck } from "lucide-react";

const META = {
  verified_organizer: { label: "Organisateur vérifié", Icon: ShieldCheck },
  top_event: { label: "Top événement", Icon: Star },
  exhibitor_choice: { label: "Choix des exposants", Icon: Users },
  popular: { label: "Événement populaire", Icon: TrendingUp },
  editorial_pick: { label: "Sélection éditoriale", Icon: BookmarkCheck },
};

/**
 * Display earned badges as horizontal pills.
 * Props:
 *  - badges: array of badge ids
 *  - variant: "card" (small, on event card) | "detail" (larger, with text)
 *  - max: limit displayed count (default Infinity)
 */
export default function Badges({ badges = [], variant = "card", max = Infinity }) {
  if (!badges.length) return null;
  const shown = badges.slice(0, max);
  const extra = badges.length - shown.length;

  if (variant === "card") {
    return (
      <div className="flex items-center gap-1.5 flex-wrap">
        {shown.map((id) => {
          const m = META[id];
          if (!m) return null;
          const Icon = m.Icon;
          const isEditorial = id === "editorial_pick";
          return (
            <span
              key={id}
              title={m.label}
              data-testid={`badge-card-${id}`}
              className={`inline-flex items-center gap-1 px-2 py-0.5 text-[10px] uppercase tracking-[0.18em] font-bold ${
                isEditorial
                  ? "bg-accent text-white"
                  : "bg-ink/[0.06] text-ink/75"
              }`}
            >
              <Icon className="h-3 w-3" />
              <span className="hidden sm:inline">{m.label}</span>
            </span>
          );
        })}
        {extra > 0 && (
          <span className="text-[10px] text-ink/40 font-mono">+{extra}</span>
        )}
      </div>
    );
  }

  // detail variant — larger, full label visible always
  return (
    <div className="flex flex-wrap gap-2">
      {shown.map((id) => {
        const m = META[id];
        if (!m) return null;
        const Icon = m.Icon;
        const isEditorial = id === "editorial_pick";
        return (
          <span
            key={id}
            data-testid={`badge-detail-${id}`}
            className={`inline-flex items-center gap-2 px-3 py-1.5 text-[11px] uppercase tracking-[0.2em] font-bold border ${
              isEditorial
                ? "bg-accent text-white border-accent"
                : "bg-cream-50 text-ink/85 border-ink/15"
            }`}
          >
            <Icon className="h-3.5 w-3.5" />
            {m.label}
          </span>
        );
      })}
    </div>
  );
}
